import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {DragDropContext} from 'react-beautiful-dnd';
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {set} from "object-path-immutable";
import DestinationColumns from "./DestinationColumns";
import SourceColumns from "./SourceColumns";
import {getLabelByName} from "../getLabelByName";
import {useSelector} from "react-redux";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex'
    }
}));
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const ColumnsSetup = ({open, onClose, schema, destination, apply, fieldsType, label}) => {
    const [destinationColumns, setDestinationColumns] = useState([]);
    const classes = useStyles();

    useEffect(() => {
        if (open) {
            setDestinationColumns(
                destination.map(item => {
                    return {name: item, label: getLabelByName(item, schema)}
                })
            );
        }

        return () => {
            setDestinationColumns([])
        }
    }, [open]);

    function onDragEnd(result) {
        const {destination, source} = result;


        if (!destination || destination.droppableId === 'source') return;

        //remove from destination columns
        if (destination.droppableId === 'sourceItems' && source.droppableId !== 'source') {
            setDestinationColumns(prevState => {
                return prevState.filter(item => item.name !== schema[source.index].name)
            });
            return
        }

        //reorder destination columns
        if (source.droppableId === destination.droppableId) {
            const reordered = reorder(destinationColumns, source.index, destination.index);
            setDestinationColumns(reordered);
            return
        }

        //add new in destination columns
        if (destination.droppableId === 'destinationItems') {
            const sourceItem = {name: schema[source.index].name, label: schema[source.index].label};
            const copyDestination = copy(schema, destinationColumns, source, destination, sourceItem);
            setDestinationColumns(copyDestination)
        }
    }

    function checkBoxChange(event, column) {
        if (event.target.checked === true) {
            let newItem = {name: column.name, label: column.label};
            const newColumns = set(destinationColumns, `${destinationColumns.length}`, newItem);
            setDestinationColumns(newColumns);
            return
        }

        let newColumns = destinationColumns.filter(item => item.name !== column.name);
        setDestinationColumns(newColumns)
    }

    function checkBoxAllChange(event) {
        if (event.target.checked) {
            setDestinationColumns(schema.map(i => {
                return {name: i.name, label: i.label}
            }));
            return
        }

        setDestinationColumns([])

    }

    function onApply() {
        apply(destinationColumns.map(i => i.name), fieldsType);
        onClose();
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
        >
            <DialogContent>
                <DragDropContext onDragEnd={onDragEnd}>
                    <div className={classes.container}>
                        <div>
                            <SourceColumns
                                source={schema}
                                checkBoxChange={checkBoxChange}
                                checkBoxAllChange={checkBoxAllChange}
                                destination={destinationColumns}
                            />
                        </div>
                        <div>
                            <DestinationColumns destination={destinationColumns} columnNames={label}/>
                        </div>
                    </div>
                </DragDropContext>
            </DialogContent>
            <DialogActions>
                <Button
                    color={"primary"}
                    variant={"contained"}
                    size={"small"}
                    onClick={onApply}
                >
                    Apply
                </Button>
            </DialogActions>
        </Dialog>
    )
};

export default ColumnsSetup

ColumnsSetup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    schema: PropTypes.array,
    destination: PropTypes.array,
    apply: PropTypes.func.isRequired,
    fieldsType: PropTypes.string
};
ColumnsSetup.defaultProps = {
    schema: []
};


//utils
const copy = (source, destination, droppableSource, droppableDestination, item) => {
    let isExists = destination.some(e => e.name === item.name);
    if (!isExists) {
        destination.splice(droppableDestination.index, 0, {...item});
    }
    return destination;
};
const reorder = (list, startIndex, endIndex) => {
    const [removed] = list.splice(startIndex, 1);
    list.splice(endIndex, 0, removed);
    return list;
};